module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/product_detail/gallery_2-7d733d5e4aea3e8098b464c0302c4cd7.png";